import { render, staticRenderFns } from "./ItemPdfBK.vue?vue&type=template&id=4742b5f4&scoped=true&"
import script from "./ItemPdfBK.vue?vue&type=script&lang=js&"
export * from "./ItemPdfBK.vue?vue&type=script&lang=js&"
import style0 from "./ItemPdfBK.vue?vue&type=style&index=0&id=4742b5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742b5f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VFlex,VIcon,VLayout})
